import React from 'react';
import hiringAuthorities from './hiringAuthorities';

const HiringAuthoritySelect = ({ value = [], onChange }) => {
  const selectedAuthorities = Array.isArray(value) ? value : [];

  const handleToggle = (authorityValue) => {
    if (selectedAuthorities.includes(authorityValue)) {
      onChange?.(selectedAuthorities.filter((item) => item !== authorityValue));
      return;
    }
    onChange?.([...selectedAuthorities, authorityValue]);
  };

  return (
    <div className="hiring-authority-select">
      <p className="field-help">
        Select only hiring paths you are eligible to claim. These appear near the top of federal resumes.
      </p>
      <div className="hiring-authority-options">
        {hiringAuthorities.map((authority) => (
          <label
            key={authority.value}
            className={`hiring-authority-option ${selectedAuthorities.includes(authority.value) ? 'selected' : ''}`}
          >
            <input
              type="checkbox"
              checked={selectedAuthorities.includes(authority.value)}
              onChange={() => handleToggle(authority.value)}
            />
            <span>{authority.displayValue}</span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default HiringAuthoritySelect;
